import React, { useState } from 'react'
import { Segment, Input, Header, Button, Form } from 'semantic-ui-react'
import MergeModal from './MergeModal.js'

const MergeUser = () => {
    const [sourceEmail, setSourceEmail] = useState('')
    const [targetEmail, setTargetEmail] = useState('')
    const [startMerge, setStartMerge] = useState(false)

    return (
        <Segment>
            <Header>Merge User</Header>
            <Form>
                {`Merge `}
                <Input
                    fluid
                    placeholder="Enter the email to remove"
                    value={sourceEmail}
                    onChange={(e, { value }) => setSourceEmail(value)}
                />
                {` Into `}
                <Input
                    fluid
                    placeholder="Enter the email to keep"
                    value={targetEmail}
                    onChange={(e, { value }) => setTargetEmail(value)}
                />
            </Form>
            <br />
            {startMerge && (
                <MergeModal
                    sourceEmail={sourceEmail}
                    targetEmail={targetEmail}
                    onClose={() => setStartMerge(false)}
                />
            )}
            <Button
                primary
                disabled={!sourceEmail || !targetEmail}
                content="Start"
                onClick={() => setStartMerge(true)}
            />
        </Segment>
    )
}

export default MergeUser
